import api from './api';

const proService = {
  // Get professional user profile
  getUserProfile: async () => {
    try {
      const response = await api.get('/prise-en-charge/profile');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching pro profile:', error);
      throw error;
    }
  },

  // Get all listings
  getListings: async () => {
    try {
      const response = await api.get('/prise-en-charge/listings');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching listings:', error);
      throw error;
    }
  },

  // Create a new listing
  createListing: async (listing) => {
    try {
      const response = await api.post('/prise-en-charge/listings', listing);
      return response.data;
    } catch (error) {
      console.error('Error creating listing:', error);
      throw error;
    }
  },

  // Update listing status
  updateListingStatus: async (id, status) => {
    try {
      const response = await api.put(`/prise-en-charge/listings/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating listing status:', error);
      throw error;
    }
  },

  // Delete a listing
  deleteListing: async (id) => {
    try {
      const response = await api.delete(`/prise-en-charge/listings/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting listing:', error);
      throw error;
    }
  },

  // Get all bookings
  getBookings: async () => {
    try {
      const response = await api.get('/prise-en-charge/bookings');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching bookings:', error);
      throw error;
    }
  },

  // Update booking status
  updateBookingStatus: async (id, status) => {
    try {
      const response = await api.put(`/prise-en-charge/bookings/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating booking status:', error);
      throw error;
    }
  },

  // Get all messages
  getMessages: async () => {
    try {
      const response = await api.get('/prise-en-charge/messages');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching messages:', error);
      throw error;
    }
  },

  // Mark message as read
  markMessageRead: async (id) => {
    try {
      const response = await api.put(`/prise-en-charge/messages/${id}/read`);
      return response.data;
    } catch (error) {
      console.error('Error marking message as read:', error);
      throw error;
    }
  },

  // Get analytics
  getAnalytics: async () => {
    try {
      const response = await api.get('/prise-en-charge/analytics');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching analytics:', error);
      throw error;
    }
  },

  // Update a listing
  updateListing: async (id, listingData) => {
    try {
      const response = await api.put(`/prise-en-charge/listings/${id}`, listingData);
      return response.data;
    } catch (error) {
      console.error('Error updating listing:', error);
      throw error;
    }
  },

  // Reply to a message
  replyToMessage: async (id, replyContent) => {
    try {
      const response = await api.post(`/prise-en-charge/messages/${id}/reply`, { content: replyContent });
      return response.data;
    } catch (error) {
      console.error('Error replying to message:', error);
      throw error;
    }
  },

  // Get booking details
  getBookingDetails: async (id) => {
    try {
      const response = await api.get(`/prise-en-charge/bookings/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching booking details:', error);
      throw error;
    }
  }
};

export default proService;